var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"route-two-dir"}},[_c('h4',[_vm._v(_vm._s(_vm.stopName))]),_c('div',{staticClass:"row"}),_c('div',{staticClass:"row"},[_c('stop-route-list',{attrs:{"routes":_vm.stopDetails.routes}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }